export const INCIDENT_STATUS_META = {
  open: { label: "Open", bg: "bg-orange-100", text: "text-orange-800", border: "border-orange-200" },
  affecting_bookings: { label: "Affecting Bookings", bg: "bg-red-100", text: "text-red-800", border: "border-red-200" },
  resolved: { label: "Resolved", bg: "bg-emerald-100", text: "text-emerald-800", border: "border-emerald-200" },
  cancelled: { label: "False Alarm", bg: "bg-stone-100", text: "text-stone-700", border: "border-stone-200" },
};

export const INCIDENT_TYPE_META = {
  damaged: "Damaged",
  maintenance: "Maintenance",
  late_return: "Late Return",
  unavailable: "Unavailable",
  accident: "Accident",
  weather: "Weather",
  staff_issue: "Staff Issue",
  document_issue: "Document Issue",
  other: "Other",
};

export const SEVERITY_META = {
  low: { label: "Low", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  medium: { label: "Medium", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  high: { label: "High", cls: "bg-orange-100 text-orange-900 border-orange-200" },
  critical: { label: "Critical", cls: "bg-red-100 text-red-800 border-red-200" },
};

export const IMPACT_META = {
  directly_affected: { label: "Directly Affected", cls: "bg-red-100 text-red-800 border-red-200" },
  nearby_risk: { label: "Nearby Risk", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  watch_only: { label: "Watch Only", cls: "bg-blue-100 text-blue-800 border-blue-200" },
};

export const NOTIF_META = {
  not_notified: { label: "Not notified", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  notified: { label: "Notified", cls: "bg-blue-100 text-blue-800 border-blue-200" },
  safe_again_sent: { label: "Safe-again sent", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
};

export function IncidentStatusBadge({ status, "data-testid": testId }) {
  const m = INCIDENT_STATUS_META[status] || INCIDENT_STATUS_META.open;
  return (
    <span data-testid={testId} className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${m.bg} ${m.text} ${m.border}`}>
      {m.label}
    </span>
  );
}

export function SeverityBadge({ severity }) {
  const m = SEVERITY_META[severity] || SEVERITY_META.medium;
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${m.cls}`}>
      {m.label}
    </span>
  );
}

export function ImpactBadge({ impact }) {
  const m = IMPACT_META[impact] || { label: impact, cls: "bg-slate-100 text-slate-700 border-slate-200" };
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${m.cls}`}>
      {m.label}
    </span>
  );
}

export function NotifBadge({ status }) {
  const m = NOTIF_META[status] || NOTIF_META.not_notified;
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${m.cls}`}>
      {m.label}
    </span>
  );
}
